module.exports = __webpack_public_path__ + "static/media/estat_camadas_por_tipo.d2f34dc6.png";